import React, { useRef, useState, useEffect, useContext } from 'react'
import Card from '../../../../Base/Components/Card/Card';
import CalendarWeek from '../../../../Base/Components/Form/CalendarWeek';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import { getBalanceHilazaVenta } from '../../../../API/Ventas/SalesOrderRequest';
import { toastShow } from '../../../../Base/Services/ToastService';
import { getDateProduction } from '../../../../Base/Services/FechasService';
import { baseLang } from '../../../../Base/Lang/BaseLang';
import { ConfigContext } from '../../../../Base/Context/ConfigContext/ConfigContext';
import { getLabel } from '../../../../Base/Services/Language/LanguageService';
import { setTitlePage } from '../../../../Base/Services/Config/ConfigService';
import { Button } from 'primereact/button';
import Loader from '../../../../Base/Components/Loader/Loader';
import { Toast } from 'primereact/toast';
import { RadioButton } from 'primereact/radiobutton';
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';

const BalanceHilazaScreen = () => {

    const { userAuth } = useContext(AuthContext);

    const toast = useRef(null)
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [idEstado, setIdEstado] = useState('41')
    const { config } = useContext(ConfigContext);
    const estados = [
        { IdEstado: '134', Estado: 'Released' },
        { IdEstado: '41', Estado: 'Created' },
        { IdEstado: '133,134,41', Estado: 'All' },
        {IdEstado:'133', Estado:'Complete'}
    ]

    const obtenerInformacion = async (idEstado) => {
        setLoading(true)
        if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
            toastShow(toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido.");
            setLoading(false)
            return;
        }
        const fechas = getDateProduction(dates);
        const result = await getBalanceHilazaVenta(fechas, idEstado)
        setData(result)
        setLoading(false)
    }

    const table = {
        Data: data,
        Columns: [
            {
                field: 'SalesOrder',
                header: 'Orden Venta',
                headerEn: 'Sales Order',
                className: 'small',
                Format: 'Center',
                 frozen: true,
                alignFrozen: 'left'
            },
            {
                field: 'IdYarn',
                header: 'IdYarn',
                headerEn: '',
                className: 'Xsmall',
                hidden: userAuth.IdRol === 1,
            },
            
            {
                field: 'Yarn',
                header: 'Hilaza',
                headerEn: 'Yarn',
                className: 'XXlarge',
                Sumary: 'count',
                 frozen: true,
                alignFrozen: 'left'
            },
            {
                field: 'PurchaseRequest',
                header: 'Requisa Compra',
                headerEn: 'Purchase Request',
                className: 'small',
                Format: 'Center',

            },
            {
                field: 'PurchaseOrder',
                header: 'Orden Compra',
                headerEn: 'Purchase Order',
                className: 'small',

            },
            {
                field: 'OrderDate',
                header: 'Fecha Orden',
                headerEn: 'Order Date',
                className: 'small',
                Format: 'Date',
            },
            {
                field: 'StyleCategory',
                header: 'Estilo',
                headerEn: 'StyleCategory',
                className: 'small',
            },
            {
                field: 'CustomerOrder',
                header: 'Orden Cliente',
                headerEn: 'Customer Order',
                className: 'small',
                Format: 'Center'
            },
            {
                field: 'CustomerName',
                header: 'Cliente',
                headerEn: 'Customer',
                className: 'XXalrge',
            },
            {
                field: "IdStatus",
                header: "Estado",
                headerEn: "Status",
                className: "Xsmall",
                Format: "Estado",
                body: (rowData) => ({
                    ID: rowData.IdStatus,
                    Estado: rowData.StatusName,
                }),
            },
            {
                field: 'AgentName',
                header: 'Agente',
                headerEn: 'Agent',
                className: 'small',
            },
            {
                field: 'AgenteOrdeno',
                header: 'Agente Orden Venta',
                headerEn: 'Agent Sales Order',
                className: 'small',
            },
            {
                field: 'CompanyName',
                header: 'Comprador',
                headerEn: 'Buyer',
                className: 'medium',
            },
            {
                field: 'OrderType',
                header: 'Tipo Orden',
                headerEn: 'Order Type',
                className: 'small',
            },
            {
                field: 'Terms',
                header: 'Terminos',
                headerEn: 'Terms',
                className: 'Xsmall',
            },
            {
                field: 'KgsTLoss',
                header: 'KgsTLoss',
                headerEn: 'KgsTLoss',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum'
            },
            // {
            //     field: 'KgsKnit',
            //     header: 'KgsKnit',
            //     headerEn: 'KgsKnit',
            //     className: 'small',
            //     Format: 'Currency',
            //     Sumary: 'sum'
            // },

            {
                field: 'Quantity',
                header: 'Porcentaje %',
                headerEn: 'Porcentaje %',
                className: 'Xsmall',
                width:100,
                Format: 'Porcentaje',
                // Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right'
            },
            {
                field: 'YarnRequiredY',
                header: 'Yarn Required',
                headerEn: 'Yarn Required',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum',
                 frozen: true,
                alignFrozen: 'right'
            },
            {
                field: 'KgsPR',
                header: 'KgsPR',
                headerEn: 'KgsPR',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right'
            },
            // {
            //     field: 'Pound',
            //     header: 'Pound',
            //     headerEn: 'Pound',
            //     className: 'small',
            //     Format: 'Currency',
            //     Sumary: 'sum'
            // },
            {
                field: 'BalancePR',
                header: 'Balance',
                headerEn: 'Balance',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum',
                frozen: true,
                alignFrozen: 'right'
            },
            // {
            //     field: 'KgsEX',
            //     header: 'KgsEX',
            //     headerEn: 'KgsEX',
            //     className: 'small',
            //     Format: 'Currency',
            //     Sumary: 'sum'
            // },


            {
                field: 'FechaRequisa',
                header: 'Fecha Requisa',
                headerEn: 'Request Date',
                className: 'small',
                Format: 'Date',

            },
            {
                field: 'UsuarioRequisa',
                header: 'Usuario Requisa',
                headerEn: 'Request User',
                className: 'small',

            },

            {
                field: 'FechaOrdenCompra',
                header: 'Fecha Orden Compra',
                headerEn: 'Purchase  Date',
                className: '',

            },
        ]
    }

    const BuscarByEstado = (idEstado) => {
        setIdEstado(idEstado)
        obtenerInformacion(idEstado)
    }

    useEffect(() => {
        if (dates) {
            obtenerInformacion(idEstado)
        }
        setTitlePage(getLabel(baseLang, "BalanceHilaza", config.language));
    }, [dates])

    return (
        <div>
            <Toast ref={toast} />
            <Loader loading={loading} querySelector={'#BalanceHilaza'} />
            <Card
                titulo={<div className='d-flex gap'>
                    <h3>{getLabel(baseLang, "BalanceHilaza", config.language)}</h3>
                    {/* <CalendarWeek
                        date={dates}
                        setDate={setDates}
                        selectionMode="range"
                    /> */}
                    <div className="d-flex gap align-items-center">
                        {estados.map((e) => {
                            return (
                                <div className="flex align-items-center">
                                    <RadioButton inputId={e?.IdEstado} name={e?.Estado} value={e?.IdEstado} onChange={(e) => BuscarByEstado(e.value)} checked={idEstado === e?.IdEstado} />
                                    <label htmlFor="ingredient1" className="ml-2"> {e?.Estado}</label>
                                </div>

                            )
                        })}
                    </div>
                    <Button icon='pi pi-search' onClick={() => obtenerInformacion(idEstado)} style={{ height: 40 }} />

                </div>}
                contenido={<div className='pt-4' style={{ height: '90vh' }} id='BalanceHilaza'>
                    <AgGrid table={table} />
                </div>}
            />
        </div>
    )
}

export default BalanceHilazaScreen
